<script setup lang="ts">
import { DeviceMeta, TempIcon } from '@wision/ui';
import type { MetaProps } from '@wision/ui';
import type { PropType } from 'vue';

type Value = {
  name: string;
  value: number;
  unit: string;
};

const props = defineProps({
  temp: {
    type: Object as PropType<Value>,
    default: undefined
  },
  rest: {
    type: Array as PropType<Array<Value>>,
    default: () => [],
  },
  meta: {
    type: Object as PropType<MetaProps>,
    required: true,
  },
});
</script>

<template>
  <div
    class="w-full text-white font-light font-sans"
  >
    <div class="flex flex-col justify-center">
      <div class="flex flex-row justify-center items-center align-middle">
        <div
          class="flex flex-row items-center"
        >
          <TempIcon class="h-10" />

          <div class="ml-4 text-5xl font-roboto">
            <span v-if="props.temp === undefined">-</span>
            <span v-else>{{ props.temp.value }}{{ props.temp.unit }}</span>
          </div>
        </div>
      </div>

      <div
        class="gap-2 p-4 pb-0"
        :class="{ 'columns-2 md:columns-3': props.rest.length > 1 }"
      >
        <div
          v-for="value in props.rest"
          :key="value?.name"
        >
          <div
            v-if="value"
            class="flex flex-row justify-center items-center leading-1 text-lg"
          >
            <div class="w-1 h-1 rounded-full bg-gray-300 mr-2" />
            <span class="truncate mr-1">{{ value.name }}</span>
            <span>{{ value.value }}</span>
            <span>{{ value.unit }}</span>
          </div>
        </div>
      </div>

      <DeviceMeta
        v-if="props.meta"
        v-bind="props.meta"
      />
    </div>
  </div>
</template>
